export default ({ request }) => ({
  pdTechDictionaryListApi(data = {}) {
    return request({
      url: '/factory/pd/tech/dictionary/list',
      method: 'post',
      data,
    })
  },
  pdTechDictionaryListByChooseApi(data = {}) {
    return request({
      url: '/factory/pd/tech/dictionary/listByChoose',
      method: 'post',
      data,
    })
  },
  pdTechDictionaryDetailApi(data = {}) {
    return request({
      url: '/factory/pd/tech/dictionary/detail',
      method: 'post',
      data,
    })
  },
  pdTechDictionarySaveApi(data = {}) {
    return request({
      url: '/factory/pd/tech/dictionary/save',
      method: 'post',
      data,
    })
  },
  pdTechDictionaryDelApi(data = {}) {
    return request({
      url: '/factory/pd/tech/dictionary/del',
      method: 'post',
      data,
    })
  },
})
